import { azureFetch } from "./azureFetch";

export const fetchClDetails = async (id) => {
    try {
        const response = await azureFetch('cl', { "id": id });
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor data:", error);
        throw error;
    }
};